export default __webpack_public_path__ + "static/media/cmnd.03347047.jpg";